"use strict";

$(document).ready(function () {
  $(".accordion-toggle").click(function (event) {
    // Get the target content
    var id = $(this).attr('id');
    var dropdownID = "content-" + id;

    // Prevent default link behavior
    event.preventDefault();
    var dropdownContent = document.getElementById(dropdownID);
    $(this).toggleClass("open");
    $(dropdownContent).toggleClass("active");
  });
});
document.addEventListener("DOMContentLoaded", function () {
  var faqs = document.querySelectorAll(".Collapsible");
  faqs.forEach(function (faq) {
    var question = faq.querySelector(".Collapsible__trigger");
    var answers = faq.querySelector(".Collapsible__contentOuter");
    question.addEventListener("click", function () {
      faq.classList.toggle("is-open");
    });
  });
});